import { getAuth } from "firebase/auth";
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

const devFirebaseConfig = {
  apiKey: "AIzaSyC0iQHPtlJymMRlT8rs_ryLEZvmO1Azlmo",
  authDomain: "medlyves-doctor-dev.firebaseapp.com",
  databaseURL: "https://medlyves-doctor-dev-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "medlyves-doctor-dev",
  storageBucket: "medlyves-doctor-dev.appspot.com",
  messagingSenderId: "853443805611",
  appId: "1:853443805611:web:d4f87c7f0ae2311ffb12ee",
  measurementId: "G-TF2P5CESE0",
};

const prodFirebaseConfig = {
  apiKey: "AIzaSyDV_SBEeGfInI_qcEgWbH7UYdnx1pecbic",
  authDomain: "medlyves-doctor.firebaseapp.com",
  databaseURL: "https://medlyves-doctor-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "medlyves-doctor",
  storageBucket: "medlyves-doctor.firebasestorage.app",
  messagingSenderId: "1091315824870",
  appId: "1:1091315824870:web:f8159f9f5257b230f2a327",
  measurementId: "G-VRFLFGCEB2"
};
const env = process.env.REACT_APP_ENV;
const app = initializeApp(
  prodFirebaseConfig
);
const auth = getAuth(app);
const database = getDatabase(app)
export { database };
export default auth;
